export const normalizeMobile = (input) => (input ?? "").replace(/\s/g, "");

export const isValidMobile = (input) =>
  /^(07\d{8,12}|(\+44|0044)7\d{8,9})$/.test(normalizeMobile(input));

export const isValidEmail = (input) =>
  /^(?:[^\s@]+)@(?:[^\s@]+)\.(?:[^\s@]+)$/.test(input);
